// Disable some rules to keep es-lint happy
/* eslint-disable quotes */
import React from 'react';
import SuperScript from '../Components/SuperScript/SuperScript';
import { v4 as uuidv4 } from 'uuid';

function superScript({ num, text, url }) {
  return <SuperScript key={uuidv4()} num={num} text={text} url={url} />;
}

export const regionalOverviews = {
  'Coastal Hazards': {
    CISA: [
      'Sea level rise is among the most prominent climate impacts in the Carolinas, with parts of the coastline facing a higher rate of sea level rise than the global average.',
      superScript({
        num: 1,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
      'Sea level rise is causing direct damage and worsening coastal flooding and erosion, increasing storm surge, and damaging habitats.',
      superScript({
        num: 2,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
      'Local sea level rises of 1 to 2 plus feet have been observed regionally, and further increases in sea level in the next several decades are expected to result in coastal hazards such as frequent flooding. Tropical storms and hurricanes, while varying in frequency each year, also cause direct damage and exacerbate coastal flooding.',
      superScript({
        num: 3,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
      'Salt marshes and other coastal ecosystems, which offer protection to coastal areas by absorbing water and buffering storm surges, may be damaged by long term changes in temperature and rainfall patterns.',
      superScript({
        num: 4,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
    ],
    GLISA: [],
    MARISA: [
      'The coastal Mid-Atlantic has experienced some of the highest rates of sea level rise in the nation',
      superScript({
        num: 1,
        text: "Virginia's Sea Level Is Rising",
        url: 'https://sealevelrise.org/states/virginia/#:~:text=The%20sea%20level%20around%20Hampton,than%20it%20was%20in%201950.&text=This%20increase%20is%20mostly%20due,level%20rise%20in%20the%20country.',
      }),
      'since 1950 and particularly in the past ten years. Decades of tidal gauge data up to 2009 show nearly three to four times higher than the average global rate of sea level rise',
      superScript({
        num: 2,
        text: 'Fourth National Climate Assessment - Chapter 18: Northeast',
        url: 'https://nca2018.globalchange.gov/chapter/18/',
      }),
      ' in some locations. These high rates of sea level rise have been aggravated by coastal land subsidence and resulting in increases of high-tide flooding by 100-200%',
      superScript({
        num: 3,
        text: 'Fourth National Climate Assessment - Chapter 18: Northeast',
        url: 'https://nca2018.globalchange.gov/chapter/18/',
      }),
      ' in the most impacted locations over the past few decades. Above average trends in sea level rise are projected to continue through the rest of the century across the broader Northeast region.',
      superScript({
        num: 4,
        text: 'Fourth National Climate Assessment - Chapter 18: Northeast',
        url: 'https://nca2018.globalchange.gov/chapter/18/',
      }),
      'In addition to sea level rise, the coastal Mid-Atlantic has seen coastal change due to extreme storm events (e.g., Nor’easters, hurricanes), storm surges, ocean warming and acidification.',
      superScript({
        num: 5,
        text: 'Fourth National Climate Assessment - Chapter 18: Northeast',
        url: 'https://nca2018.globalchange.gov/chapter/18/',
      }),
    ],
    Default: [
      'Global mean sea level is “very likely” to rise by 1.1-4.3 feet, depending on the chosen future emissions scenario, by the end of the 21st century.',
      superScript({
        num: 1,
        text: 'NCA4 Vol 1 – Chapter 1 pg. 52',
        url: '',
      }),
      '“Sea level will not rise uniformly around the coasts of the United States and its oversea territories. Local sea level rise is likely to be greater than the global average along the U.S. Atlantic and Gulf Coasts and less than the global average in most of the Pacific Northwest.”',
      superScript({
        num: 2,
        text: 'NCA4 Vol 1 – Chapter 1 pg. 52',
        url: '',
      }),
      'The increase in sea levels will increase “the frequency and extent of high-tide flooding”, threatening the country’s “trillion-dollar coastal property market and infrastructure”.',
      superScript({
        num: 3,
        text: 'NCA4 Vol 2 – Report in Brief pg. 17',
        url: '',
      }),
    ],
  },
  // "Drought": {
  //   "CISA": [
  //     "Increasing temperatures and changing precipitation patterns are intensifying droughts across the United States. This century, projected higher average temperatures across much of the United States may lead to an increased drought frequency and magnitude.",
  //     superScript({
  //       "num": 1,
  //       "text": "Fourth National Climate Assessment, Volume 2 - Report-in-Brief",
  //       "url": "https://nca2018.globalchange.gov/downloads/NCA4_Report-in-Brief.pdf"
  //     }),
  //     " Drought, in combination with other factors (i.e., increasing temperatures, wildfires) can cause a wide range of impacts.",
  //     superScript({
  //       "num": 2,
  //       "text": "Fourth National Climate Assessment, Volume 2 - Report-in-Brief",
  //       "url": "https://nca2018.globalchange.gov/downloads/NCA4_Report-in-Brief.pdf"
  //     }),
  //     " These impacts vary by region and include stress on water supplies; reducing tree cover, growth, and carbon storage; threatening electricity generation from water-cooled power plants; and declining food production due to reduced livestock health and crop yields.",
  //     <br key={'break'}></br>,
  //     "Although the Carolinas usually receive ample rain, severe droughts lasting years have occurred several times in the past century.",
  //     superScript({
  //       "num": 3,
  //       "text": "Fourth National Climate Assessment - Chapter 19: Southeast",
  //       "url": "https://nca2018.globalchange.gov/chapter/19/"
  //     }),
  //     " Droughts can also develop quickly if a lack of rain combines with high temperatures.",
  //     superScript({
  //       "num": 4,
  //       "text": "National Integrated Drought Information System",
  //       "url": "https://www.drought.gov/dews/southeast"
  //     }),
  //     " Droughts can pose significant risks for agriculture, water resources, native ecosystems, and wildfire occurrence.",
  //     superScript({
  //       "num": 5,
  //       "text": "Fourth National Climate Assessment - Chapter 19: Southeast",
  //       "url": "https://nca2018.globalchange.gov/chapter/19/"
  //     }),
  //     " With climate change causing higher temperatures and more variable rainfall patterns, both slowly evolving droughts and quick onset droughts are potential hazards in the region."
  //   ],
  //   "GLISA": [
  //     "Increasing temperatures and changing precipitation patterns are intensifying droughts when they occur, with varying impacts across the United States. In the future, projected higher average temperatures across much of the United States may lead to an increased frequency and magnitude of agricultural drought",
  //     superScript({
  //       "num": 6,
  //       "text": "Fourth National Climate Assessment, Volume 2 - Report-in-Brief",
  //       "url": "https://nca2018.globalchange.gov/downloads/NCA4_Report-in-Brief.pdf"
  //     }),
  //     " (when crops become affected by drought). Drought, in combination with other factors (i.e., increasing temperatures, wildfires) can cause a wide range of impacts",
  //     superScript({
  //       "num": 2,
  //       "text": "Fourth National Climate Assessment, Volume 2 - Report-in-Brief",
  //       "url": "https://nca2018.globalchange.gov/downloads/NCA4_Report-in-Brief.pdf"
  //     }),
  //     ", including putting stress on water supplies, reducing tree cover, growth and carbon storage, threatening electricity generation from water-cooled power plants, and declining food production due to reduced livestock health and crop yields."
  //   ],
  //   "MARISA": [
  //     "Increasing temperatures and changing precipitation patterns are intensifying droughts when they occur, with varying impacts across the United States. In the future, projected higher average temperatures across much of the United States may lead to an increased frequency and magnitude of agricultural drought",
  //     superScript({
  //       "num": 1,
  //       "text": "Fourth National Climate Assessment, Volume 2 - Report-in-Brief",
  //       "url": "https://nca2018.globalchange.gov/downloads/NCA4_Report-in-Brief.pdf"
  //     }),
  //     " (when crops become affected by drought). Drought, in combination with other factors (i.e., increasing temperatures, wildfires) can cause a wide range of impacts",
  //     superScript({
  //       "num": 2,
  //       "text": "Fourth National Climate Assessment, Volume 2 - Report-in-Brief",
  //       "url": "https://nca2018.globalchange.gov/downloads/NCA4_Report-in-Brief.pdf"
  //     }),
  //     ", including putting stress on water supplies, reducing tree cover, growth and carbon storage, threatening electricity generation from water-cooled power plants, and declining food production due to reduced livestock health and crop yields."
  //   ],
  //   "Default": [
  //     'Increasing temperatures and changing precipitation patterns are intensifying droughts when they occur, with varying impacts across the United States. In the future, projected higher average temperatures across much of the United States may lead to an increased frequency and magnitude of agricultural drought',
  //     superScript({
  //       "num": 1,
  //       "text": "Fourth National Climate Assessment, Volume 2 - Report-in-Brief",
  //       "url": "https://nca2018.globalchange.gov/downloads/NCA4_Report-in-Brief.pdf"
  //     }),
  //     ' (when crops become affected by drought). Drought, in combination with other factors (i.e., increasing temperatures, wildfires) can cause a wide range of impacts',
  //     superScript({
  //       "num": 2,
  //       "text": "Fourth National Climate Assessment, Volume 2 - Report-in-Brief",
  //       "url": "https://nca2018.globalchange.gov/downloads/NCA4_Report-in-Brief.pdf"
  //     }),
  //     ', including putting stress on water supplies, reducing tree cover, growth and carbon storage, threatening electricity generation from water-cooled power plants, and declining food production due to reduced livestock health and crop yields.'
  //   ]
  // },
  'Extreme Rainfall/Flooding': {
    CISA: [
      'The Southeast experiences flooding due to both short-duration heavy rainfall events and longer periods of elevated rainfall. In coastal regions, high tide or storm surge can increase the magnitude of flooding. Extreme rainfall events are rising across the region due to climate change, particularly in recent decades',
      superScript({
        num: 1,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
      ', and are predicted to increase by 200-300% by the end of the century. These events, such as the 2015 extreme rainfall event, cause large monetary damages and/or loss of life and over time damage infrastructure and ecosystems.',
      superScript({
        num: 2,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
      ' Smaller or more localized floods (e.g., recurrent or ‘nuisance’ floods) can cause harm to the economy, transportation and public health.',
      superScript({
        num: 3,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
      'Both the frequency and severity of flood events are expected to rise this century, particularly in low-lying areas and coastal areas.',
      superScript({
        num: 4,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
    ],
    GLISA: [
      'The Great Lakes region has experienced an increase in the frequency of the heaviest 1% of extreme precipitation events',
      superScript({
        num: 1,
        text: 'Extreme Precipitation',
        url: 'https://glisa.umich.edu/resources-tools/climate-impacts/extreme-precipitation/',
      }),
      ' over the past several decades. These events have amplified the risk of flooding affecting stormwater management, water quality, public health, and transportation',
      superScript({
        num: 2,
        text: 'Extreme Precipitation',
        url: 'https://glisa.umich.edu/resources-tools/climate-impacts/extreme-precipitation/',
      }),
      ' for communities. Observations show the significant increases in the frequency of extreme precipitation events in the Midwestern part',
      superScript({
        num: 3,
        text: 'Climate Science Special Report - Chapter 7: Figure 7.4 Observed Changes in Heavy Precipitation',
        url: 'https://science2017.globalchange.gov/chapter/7#fig-7-4',
      }),
      ' of the United States. Model projections of extreme precipitation vary throughout the Great Lakes region, but the increasing frequency and intensity of extreme precipitation events are anticipated to continue',
      superScript({
        num: 4,
        text: 'Extreme Precipitation',
        url: 'https://glisa.umich.edu/resources-tools/climate-impacts/extreme-precipitation/',
      }),
      ' by the mid-to-late 21st century.',
    ],
    MARISA: [
      'The Mid-Atlantic region has experienced increases in extreme rainfall events',
      superScript({
        num: 1,
        text: 'Changes in Extreme Precipitation from 1976 to Present',
        url: 'https://www.midatlanticrisa.org/data-tools/climate-data-tools/extreme-precipitation-historic.html',
      }),
      ' since at least 2006, exacerbating stormwater challenges throughout the region. The Mid-Atlantic sits within the larger Northeast region, which has experienced the largest increases in the intensity and frequency of extreme precipitation',
      superScript({
        num: 2,
        text: 'Fourth National Climate Assessment - Chapter 7: Ecosystems, Ecosystem Services, and Biodiversity',
        url: 'https://nca2018.globalchange.gov/chapter/7/',
      }),
      ' of anywhere in the United States. Research examining downscaled global climate model (GCM) output has also shown that these trends are anticipated to continue',
      superScript({
        num: 3,
        text: 'Chesapeake Bay Watershed Climate Impacts Summary and Outlook for 2018',
        url: 'https://www.midatlanticrisa.org/climate-summaries/2018/11.html',
      }),
      ' through the middle to late 21st century. As a result, urban and coastal flooding could be magnified and more frequent in the future',
      superScript({
        num: 4,
        text: 'Future Precipitation Impacts on Stormwater Management',
        url: 'https://www.midatlanticrisa.org/data-tools/climate-data-tools/pittsburgh-flooding.html',
      }),
      ' in the absence of adaptation.',
    ],
    Default: ['Information coming soon.'],
  },
  Fog: {
    CISA: [],
    GLISA: [],
    MARISA: [],
    Default: [
      'Typically, fog forms because of an increase in atmospheric moisture, cooling to the point where the air near the Earth’s surface is saturated with moisture, or some combination of these.',
      superScript({
        num: 1,
        text: 'National Weather Service: Fog Tutorial',
        url: 'https://www.weather.gov/lmk/fog_tutorial',
      }),
      ' Predominant causes vary by region and each event depends on specific conditions. Consequently, how climate change will impact fog patterns and occurrence is uncertain. Some of the atmospheric conditions that play a role in fog formation could shift due to climate change. For example, temperature changes could alter the saturation rate; increased evaporation rates could add moisture to the atmosphere; winds could shift in such a way as to increase or decrease the movement of moisture. Scenarios for the future will result from a complex set of changes unique to each location.',
    ],
  },
  'Great Lakes Hazards': {
    CISA: [],
    GLISA: [],
    MARISA: [],
    Default: [
      'Lake-effect snowfall amounts vary depending on lake ice coverage',
      superScript({
        num: 1,
        text: 'Sustained Assessment of the Great Lakes: Lake Ice Overview',
        url: 'https://glisa.umich.edu/sustained-assessment/lake-ice/',
      }),
      ' and atmospheric conditions.',
      superScript({
        num: 2,
        text: 'Snow in the Great Lakes: Past, Present, and Future',
        url: 'https://glisa.umich.edu/resources-tools/climate-impacts/snow-in-the-great-lakes-past-present-and-the-future/',
      }),
      ' As global temperatures continue to rise and further warm the Great Lakes, areas in lake-effect zones will continue to see increasing lake-effect snowfall',
      superScript({
        num: 3,
        text: 'Lake-effect Snow in the Great Lakes Region',
        url: 'https://glisa.umich.edu/resources-tools/climate-impacts/lake-effect-snow-in-the-great-lakes-region/',
      }),
      ' as a warmer atmosphere will be able to hold increasing amounts of moisture, and this trend is likely to continue until those snowfall events shift to rainfall',
      superScript({
        num: 4,
        text: 'NCA4 Vol 2 – Chapter 21, Figure 21.8: The Changing Great Lakes',
        url: 'https://nca2018.globalchange.gov/chapter/21#fig-21-8',
      }),
      ' due to the warming winters.',
      <br key='glh-break'></br>,
      'Great Lakes water levels have been characterized by prolonged high water conditions, record-high lake levels, flooding, and shoreline erosion',
      superScript({
        num: 5,
        text: 'Sustained Assessment of the Great Lakes: Lake Levels Overview',
        url: 'https://glisa.umich.edu/sustained-assessment/lake-levels/',
      }),
      ' resulting from high wind and wave events since 2014. Both high and low water levels pose challenges, and model projections suggest the changing climate will increase the variability of both high and low Great Lakes water levels.',
      superScript({
        num: 6,
        text: 'Lake Levels',
        url: 'https://glisa.umich.edu/resources-tools/climate-impacts/lake-levels/',
      }),
    ],
  },
  'Severe Weather': {
    CISA: [],
    GLISA: [
      'Much of the United States experiences similar types of severe weather (e.g., tornadoes, thunderstorms, high winds, etc.) throughout the year. The occurrences of storm activity are documented in storm reports determined by visual sightings and damage assessments,',
      superScript({
        num: 1,
        text: 'Climate Science Special Report - Chapter 9: Extreme Storms',
        url: 'https://science2017.globalchange.gov/chapter/9/',
      }),
      ' and recent reports reveal increasing trends in the frequency of tornadic activity and outbreaks',
      superScript({
        num: 2,
        text: 'Climate Science Special Report - Chapter 9: Extreme Storms',
        url: 'https://science2017.globalchange.gov/chapter/9#section-3',
      }),
      ' over the past decades. Trends in hail and severe thunderstorm winds are less conclusive due to the availability of reliable records. Climate model projections suggest the increasing frequency of severe weather activity by the mid-to-late 21st century,',
      superScript({
        num: 3,
        text: 'Robust increases in severe thunderstorm environments in response to greenhouse forcing',
        url: 'https://www.pnas.org/content/110/41/16361',
      }),
      ' but the results are limited in providing details on the environmental conditions required in certain regions.',
    ],
    MARISA: [],
    Default: [
      'Much of the United States experiences similar types of severe weather (e.g., tornadoes, thunderstorms, high winds, etc.) throughout the year. The occurrences of storm activity are documented in storm reports determined by visual sightings and damage assessments',
      superScript({
        num: 1,
        text: 'Climate Science Special Report - Chapter 9: Extreme Storms',
        url: 'https://science2017.globalchange.gov/chapter/9/',
      }),
      ', and recent reports reveal increasing trends in the frequency of tornadic activity and outbreaks',
      superScript({
        num: 2,
        text: 'Climate Science Special Report - Chapter 9: Extreme Storms',
        url: 'https://science2017.globalchange.gov/chapter/9/#section-3',
      }),
      'over the past decades. Trends in hail and severe thunderstorm winds are less conclusive due to the availability of reliable records. Climate model projections suggest the increasing frequency of severe weather activity by the mid-to-late 21st century',
      superScript({
        num: 3,
        text: 'Robust increases in severe thunderstorm environments in response to greenhouse forcing',
        url: 'https://www.pnas.org/content/110/41/16361',
      }),
      ', but the results are limited in providing details on the environmental conditions required in certain regions.',
    ],
  },
  'Tropical Storms/Hurricanes': {
    CISA: [
      'The Carolinas have experienced several damaging tropical storms / hurricanes over the past decade. While hurricane activity in the Atlantic has increased since 1970',
      superScript({
        num: 1,
        text: 'Climate Science Special Report - Chapter 9: Extreme Storms',
        url: 'https://science2017.globalchange.gov/report_section/9/9.2/',
      }),
      ', it remains difficult to predict the number of storms in any given year. However, climate change is expected to increase the rainfall associated with tropical storms. Models project increasing numbers of strong hurricanes and rapid intensification of tropical storms, which could especially impact the region.',
      superScript({
        num: 2,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
      ' Additional hazards to consider include sea level rise exacerbating a hurricane’s storm surge and slow-moving tropical storms causing indirect damages from heavy rainfall and flooding.',
      superScript({
        num: 3,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
    ],
    GLISA: [],
    MARISA: [
      'The Mid-Atlantic and the larger Northeast region have historically experienced a lower frequency of tropical storms and hurricanes',
      superScript({
        num: 1,
        text: 'Chesapeake Bay Watershed Climate Impacts Summary and Outlook: Fall 2019',
        url: 'https://www.midatlanticrisa.org/climate-summaries/2019/12.html#part-4-hurricanes-and-tropical-',
      }),
      ' compared to other regions of the United States, receiving 6% of annual tropical storms and hurricanes that occured over the continental U.S. between 1990 to 2017.',
      superScript({
        num: 2,
        text: 'An Energetic Perspective on United States Tropical Cyclone Landfall Droughts',
        url: 'https://agupubs.onlinelibrary.wiley.com/doi/full/10.1002/2017GL076071',
      }),
      ' In terms of timing, the majority of tropical storms fall in the Mid-Atlantic region in September',
      superScript({
        num: 3,
        text: 'Mid-Atlantic Regional Climate Impacts Summary and Outlook: Fall 2020',
        url: 'https://www.midatlanticrisa.org/climate-summaries/2020/12.html#part-4-midatlantic-hurricane-t-',
      }),
      ', followed by August, and the distribution of storms across hurricane season months has remained relatively constant over time. In the Mid-Atlantic, the years from 2000–2020 saw nearly twice as many hurricanes',
      superScript({
        num: 4,
        text: 'Mid-Atlantic Regional Climate Impacts Summary and Outlook: Fall 2020',
        url: 'https://www.midatlanticrisa.org/climate-summaries/2020/12.html#part-4-midatlantic-hurricane-t-',
      }),
      ' as the preceding two decades—1980–2000, but there are no observed changes in the intensity',
      superScript({
        num: 5,
        text: 'Mid-Atlantic Regional Climate Impacts Summary and Outlook: Fall 2020',
        url: 'https://www.midatlanticrisa.org/climate-summaries/2020/12.html#part-4-midatlantic-hurricane-t-',
      }),
      ' of hurricanes or tropical storms.',
    ],
    Default: ['Information coming soon.'],
  },
  'Extreme Heat': {
    CISA: [
      'Warm temperature extremes (e.g. very hot days and/or heatwaves) are expected to be among the primary hazards in the Carolinas due to climate change. Heatwaves pose a particular hazard to public health (such as heat-related illness and deaths)',
      superScript({
        num: 1,
        text: 'Convergence of Climate-Health Vulnerabilities: Heat',
        url: 'https://convergence.unc.edu/climate-extremes/heat/',
      }),
      ', especially in cities and households without access to cooling and/or green spaces. The majority of the region’s cities are currently experiencing worsening heat waves',
      superScript({
        num: 2,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
      ', and increased heat may further limit outdoor work and harm crops and livestock in rural areas',
      superScript({
        num: 3,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
      ', by 2090 resulting in the highest labor productivity declines nationally . In addition to public health and agriculture, warm temperature extremes impact energy systems, water management, forestry, manufacturing, and tourism.',
      superScript({
        num: 4,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
    ],
    GLISA: [
      'Warming temperatures and increased humidity in the Midwest have led to more extreme heat events in the past, and such conditions have led to dangerous living conditions in metropolitan areas',
      superScript({
        num: 1,
        text: 'NCA4 Vol 2 – Chapter 21, Key Message 4: Human Health',
        url: 'https://nca2018.globalchange.gov/chapter/21#key-message-4',
      }),
      ' such as Detroit (MI), Chicago (IL), Minneapolis/St. Paul (MN), and Milwaukee (WI). The Great Lakes have experienced warmer lake surface temperatures and increasing summertime evaporation rates',
      superScript({
        num: 2,
        text: 'NCA4 Vol 2 – Chapter 21, Box 21.1: Focus on the Great Lakes',
        url: 'https://nca2018.globalchange.gov/chapter/21#box-21_1',
      }),
      ' due to the warming air temperatures. Model projections suggest annual average temperature in the Midwest to continue to increase by the mid-to-late 21st century,',
      superScript({
        num: 3,
        text: 'Climate Science Special Report - Chapter 6: Temperature Changes in the United States',
        url: 'https://science2017.globalchange.gov/chapter/6#section-3',
      }),
      ' and southern parts of the region (i.e., Illinois and Indiana) will experience the greatest increase in the number of days over 90°F',
      superScript({
        num: 4,
        text: 'Climate Science Special Report - Chapter 6: Figure 6.9 Projected Change Tmax/Tmin',
        url: 'https://science2017.globalchange.gov/chapter/6#fig-6-9',
      }),
      ' compared to areas further north by the mid-21st century.',
    ],
    MARISA: [
      'Extreme heat and extreme heat events, such as heat waves, can impact human health',
      superScript({
        num: 1,
        text: 'Extreme Heat Can Impact Our Health in Many Ways',
        url: 'https://www.apha.org/-/media/files/pdf/factsheets/climate/extreme_heat.ashx?la=en&hash=22EA45C66C7A83AC397E16AB93056A42C00FFB31',
      }),
      ', agriculture',
      superScript({
        num: 2,
        text: 'Future crop production threatened by extreme heat',
        url: 'https://iopscience.iop.org/article/10.1088/1748-9326/9/4/041001/pdf#:~:text=High%20temperatures%20affect%20crops%20in,weight%20%5B11%E2%80%9314%5D',
      }),
      ', ecosystems',
      superScript({
        num: 3,
        text: 'Ecosystem impacts of climate extremes crucially depend on the timing',
        url: 'https://www.pnas.org/content/113/21/5768',
      }),
      ' and the built environment.',
      superScript({
        num: 4,
        text: 'High and Low Temperatures',
        url: 'https://www.epa.gov/sites/production/files/2016-08/documents/print_high-low-temps-2016.pdf',
      }),
      ' Across the Mid-Atlantic, future projections of daily maximum warm temperatures show increases in the average annual number of days with extreme temperatures from 2011-2099 compared to 1981-2010.',
      superScript({
        num: 5,
        text: 'Modeled Historic and Future Extreme Temperature',
        url: 'https://www.midatlanticrisa.org/data-tools/climate-data-tools/extreme-temperatures-projected.html',
      }),
      ' Projections across the larger Northeast region indicate that regional increases in average temperatures are anticipated to be the largest among the contiguous United States.',
      superScript({
        num: 6,
        text: 'Fourth National Climate Assessment - Chapter 18: Northeast',
        url: 'https://nca2018.globalchange.gov/chapter/18/',
      }),
      ' In addition, daily minimum temperatures are anticipated to warm at a faster rate',
      superScript({
        num: 7,
        text: 'Climate Change 2013: The Physical Science Basis',
        url: 'https://www.ipcc.ch/report/ar5/wg1/',
      }),
      ' than daily maximum temperatures. Since 1981, the Mid-Atlantic has seen increases in the number of days with warm daily low temperatures',
      superScript({
        num: 8,
        text: 'Historical Average Annual Number of Days with Warm Low Temperatures',
        url: 'https://www.midatlanticrisa.org/data-tools/climate-data-tools/historical-low-temperatures.html',
      }),
      ', and these increases are projected to continue',
      superScript({
        num: 9,
        text: 'Future Projected Average Annual Number of Days with Warm Low Temperatures',
        url: 'https://www.midatlanticrisa.org/data-tools/climate-data-tools/projected-low-temperatures.html',
      }),
      ' into the future.',
    ],
    Default: ['Information coming soon.'],
  },
  Wildfire: {
    CISA: [],
    GLISA: [],
    MARISA: [],
    Default: [
      'Wildfires occur across many areas of the United States, impacting public health and safety, public and private property, ecosystems, among other effects. Wildfire frequencies could increase with changing precipitation and warmer temperatures',
      superScript({
        num: 1,
        text: 'Fourth National Climate Assessment, Volume 2 - Report-in-Brief',
        url: 'https://nca2018.globalchange.gov/downloads/NCA4_Report-in-Brief.pdf',
      }),
      ', exacerbating these effects. In particular, more frequent and severe wildfires could lead to a degradation of air quality',
      superScript({
        num: 2,
        text: 'Fourth National Climate Assessment, Volume 2 - Report-in-Brief',
        url: 'https://nca2018.globalchange.gov/downloads/NCA4_Report-in-Brief.pdf',
      }),
      ', which in turn has significant implications on respiratory health, visibility and outdoor recreation. They could also result in significant increases in response and recovery costs',
      superScript({
        num: 3,
        text: 'The True Cost of Wildfire in the Western U.S.',
        url: 'https://www.blm.gov/or/districts/roseburg/plans/collab_forestry/files/TrueCostOfWilfire.pdf',
      }),
      ', damaging landslides and debris flows',
      superScript({
        num: 4,
        text: 'Fourth National Climate Assessment, Volume 2 - Report-in-Brief',
        url: 'https://nca2018.globalchange.gov/downloads/NCA4_Report-in-Brief.pdf',
      }),
      ', and major disruptions to ecosystems.',
      superScript({
        num: 5,
        text: 'Climate Science Special Report - Chapter 8: Droughts, Floods, and Wildfire',
        url: 'https://science2017.globalchange.gov/chapter/8/',
      }),
    ],
  },
  'Winter Weather': {
    CISA: [
      'Average temperatures in the Carolinas are rising in the past two decades, particularly in the winter season',
      superScript({
        num: 1,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
      ', resulting in fewer years with high snowfall',
      superScript({
        num: 2,
        text: 'Climate Science Special Report - Chapter 9: Extreme Storms',
        url: 'https://science2017.globalchange.gov/report_section/9/9.4/',
      }),
      ' and decreases in the length of the freezing period by over 1 week. This shift has important implications for agriculture, public health, and ecological changes such as invasive species and habitats.',
      superScript({
        num: 3,
        text: 'Fourth National Climate Assessment - Chapter 19: Southeast',
        url: 'https://nca2018.globalchange.gov/chapter/19/',
      }),
      ' However, hazardous winter weather extremes will still occur even if average temperature is rising. The region may face unusual winter weather extremes, such as a temporary dip in the jet stream',
      superScript({
        num: 4,
        text: 'Influence of Anthropogenic Climate Change on Planetary Wave Resonance and Extreme Weather Events',
        url: 'https://www.nature.com/articles/srep45242',
      }),
      ' forcing hazardous winter weather southward.',
    ],
    GLISA: [
      'Winter temperatures in the Great Lakes region are warming faster than in other seasons due to rising temperatures',
      superScript({
        num: 1,
        text: 'Temperature',
        url: 'https://glisa.umich.edu/resources-tools/climate-impacts/temperature/',
      }),
      ' over the past several decades. The changing winter conditions have affected the snowfall characteristics',
      superScript({
        num: 2,
        text: 'Snow in the Great Lakes: Past, Present, and Future',
        url: 'https://glisa.umich.edu/resources-tools/climate-impacts/snow-in-the-great-lakes-past-present-and-the-future/',
      }),
      ', the lake-ice coverage',
      superScript({
        num: 3,
        text: 'Great Lakes Ice Coverage',
        url: 'https://glisa.umich.edu/resources-tools/climate-impacts/great-lakes-ice-coverage/',
      }),
      ', and the freeze-thaw cycles (FTCs) trends',
      superScript({
        num: 4,
        text: 'Freeze-Thaw Cycles',
        url: 'https://glisa.umich.edu/resources-tools/climate-impacts/freeze-thaw-cycles/',
      }),
      ' seen throughout the region. Models project winter temperatures to increase more in the northern parts of the region compared to parts further south in the Great Lakes region.',
    ],
    MARISA: [
      'Changes in precipitation and temperature across the Mid-Atlantic are shifting snowfall and winter weather in the region. Research has shown that warming winter temperatures lead to a shorter snow season',
      superScript({
        num: 1,
        text: 'Fourth National Climate Assessment - Chapter 18: Northeast',
        url: 'https://nca2018.globalchange.gov/chapter/18/',
      }),
      ', particularly in the Northeast. This results in more winter precipitation falling as rain rather than snow, a trend projected to continue',
      superScript({
        num: 2,
        text: 'Fourth National Climate Assessment - Chapter 18: Northeast',
        url: 'https://nca2018.globalchange.gov/chapter/18/',
      }),
      ' into the future. This trend is true across the Northeast, but is particularly evident in the Mid-Atlantic as the snow-rain transition zone moves northward.',
      superScript({
        num: 3,
        text: 'Fourth National Climate Assessment - Chapter 18: Northeast',
        url: 'https://nca2018.globalchange.gov/chapter/18/',
      }),
    ],
    Default: ['Information coming soon.'],
  },
};
